<ng-template vdrDialogTitle>{{ 'common.select-display-language' | translate }}</ng-template>

<div *ngFor="let code of availableLanguages" >
    <button class="btn btn-link btn-sm" (click)="setLanguage(code)">
        <clr-icon [attr.shape]="code === currentLanguage ? 'dot-circle' : 'circle'"></clr-icon>
        {{ code | uppercase }} ({{ code | localeLanguageName }})
    </button>
</div>
